export enum STEP {
  UNDEFINED = 0,
  USE_CASE_MENU = 1,
  CONFIG_MENU = 2,
  USER_FORM_PERSONAL = 3,
  USER_FORM_DOCUMENT = 4,
  FACE_CAPTURE = 5,
  BIOSEAL_DISPLAY = 6
}

export enum VaccinationSTEP {
  UNDEFINED = 0,
  USE_CASE_MENU = 1,
  USER_FORM_PERSONAL = 2,
  USER_FORM_PRACTITIONER = 3,
  USER_FORM_DOCUMENT = 4,
  FACE_CAPTURE = 5,
  BIOSEAL_DISPLAY = 6
}

export enum CovidTestSTEP {
  UNDEFINED = 0,
  USE_CASE_MENU = 1,
  USER_FORM_PERSONAL = 2,
  USER_FORM_TEST = 3,
  BIOSEAL_DISPLAY = 4
}

export enum AccreditationSTEP {
  UNDEFINED = 0,
  USE_CASE_MENU = 1,
  IDENTITY_DOCUMENT = 2,
  FACE_CAPTURE = 3,
  USER_FORM_PERSONAL = 4,
  USER_FORM_EVENT = 5,
  BIOSEAL_DISPLAY = 6
}
